<div  class="container m-0 p-0"  
    [ngClass]="[disabled ?'disabled-input':'enabled-input',overlaycontainer]">
    <label class="label span-m label-text bold-text" *ngIf="label"
        [ngClass]="!displayItem && overlay_state?'label':'no-label span-s label-text bold-text'">{{label}}</label>
    <div class="click chips-active" [tabindex]="readonly ? '-1': '0'" (click)="dropdownOverlay(origin)">
        <p #origin  class="selectable-text content-l bold-text px-2" >{{content}}</p>
        <img src="assets/down_arrow_fill.svg" class="icon-xs px-2">
    </div>
    
    <!-- <input   [ngClass]="[fontsize,overlaycontainer]" #select [ngStyle]="style" placeholder={{placeHolder}} type="text" [value]="displayItem" readonly
        (keydown)="onKeyDown($event,origin)" [disabled]="disabled" id="select">
        <img src="assets/down_arrow_fill.svg" class="icon-xs"> -->
</div>
